let xmlRequest = `
<?xml version="1.0" encoding="UTF-8"?>
<request>
    <data>
        <ownerCode>货主编码, string (50), 必填</ownerCode>
        <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
        <billType>订单类型, string (20),例如: CPFH=成品发货</billType>
        <billNo>订单号, string (50), 必填</billNo>
        <freightNumber>货运单号, string (50)</freightNumber >
        <deliUnitCode>发货仓库编号, string (50)</deliUnitCode >
        <recUnitName>收货方公司名称, string (50)</recUnitName>
        <deliDate>发货时间, string (50)</deliDate>
        <submitNo>设备编号, string (50)</submitNo>
        <recUnitCode>收货仓库编码, string (50)</recUnitCode>
        <recContectName>收货方联系人, string (50)</recContectName>
        <freightTypeName>货运方联系人, string (50)</freightTypeName>
        <recContectPhone>收货方电话, string (50)</recContectPhone>
        <details>
            <detail>
                <actualQty>实收数量, float, 必填</actualQty>
                <boxNo>容器号, string (50), 必填</boxNo>
                <epc>epc码, string (50), 多个用英文逗号分隔, 适用于RFID标签场景, 通道机下发实收数量, 必填</epc>
            </detail>
        </details>
    </data>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.entryorder.receive.js